module.exports = __webpack_public_path__ + "img/move_lg.e159e5ec.png";